import React from "react";
import { motion } from "framer-motion";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../common/SafeIcon";

const { FiArrowDown, FiGlobe } = FiIcons;

export default function LegalLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-sitechs-darkgray overflow-x-hidden" dir="rtl">
      {/* Background particles (reuse App.css styles) */}
      <div className="fixed inset-0 pointer-events-none">
        {[...Array(14)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 12}s`,
              animationDuration: `${12 + Math.random() * 8}s`,
            }}
          />
        ))}
      </div>

      {/* Mouse-independent soft gradient */}
      <div
        className="fixed inset-0 pointer-events-none opacity-25"
        style={{
          background:
            "radial-gradient(600px at 20% 20%, rgba(46,184,230,0.12), transparent 40%)",
        }}
      />

      {/* Top logo */}
      <a
        href="/"
        className="absolute top-4 left-2 md:right-4 md:left-auto z-50"
        aria-label="חזרה לדף הבית"
      >
        <img
          src="/images/sitechs_logo_mini-light.png"
          alt="Sitechs"
          style={{
          width: '140px',
          maxWidth: '30vw',
          height: 'auto',
          zIndex: 1000
          }}
          className="h-14 select-none pointer-events-auto hover:opacity-90 transition-opacity"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </a>

      {/* Header Section */}
      <section className="relative pt-28 pb-12 md:py-28 overflow-hidden">
        <div className="absolute inset-0 cyber-grid opacity-20"></div>
        <div className="absolute top-20 left-10 w-64 h-64 bg-sitechs-blue/20 rounded-full morph-animation blur-3xl"></div>
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-accent-purple/20 rounded-full morph-animation blur-3xl"
          style={{ animationDelay: "4s" }}
        ></div>

        <div className="container mx-auto px-4 relative">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-6xl font-extrabold mb-4">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sitechs-blue via-accent-cyan to-sitechs-blue animate-gradient">
                {title}
              </span>
            </h1>
            {subtitle && (
              <p className="text-gray-300 text-lg">{subtitle}</p>
            )}
          </motion.div>
        </div>
      </section>

      {/* Content Card */}
      <section className="pb-24 relative">
        <div className="container mx-auto px-4">
          <div className="relative bg-[#eeeeee] backdrop-blur-md border border-gray-700 rounded-2xl shadow-lg">
            <div className="p-6 md:p-10">
              {children}
            </div>
          </div>
          <div className="flex justify-center mt-8">
            <a
              href="/"
              className="text-sm text-gray-400 hover:text-sitechs-blue transition-colors inline-flex items-center gap-2"
            >
              <SafeIcon icon={FiGlobe} className="text-base" />
              חזרה לדף הבית
            </a>
          </div>
        </div>
      </section>

      {/* Bottom bar (minimal) */}
      <footer className="border-t border-gray-800 py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex gap-6 text-sm">
              <a href="/terms" className="text-gray-500 hover:text-sitechs-blue transition-colors">
                תנאי שימוש
              </a>
              <a href="/privacy" className="text-gray-500 hover:text-sitechs-blue transition-colors">
                מדיניות פרטיות
              </a>
            </div>
            <p className="text-gray-500 text-sm">
              Sitechs {new Date().getFullYear()} - כל הזכויות שמורות
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}